define("calendar/components/calendar/onboarding/wizards/schedule-first-post-successful/index", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component"], function (_exports, _component, _templateFactory, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Wizard @onFinish={{@transition}} as |wizard|>
    <wizard.slide @primaryClass="tOB--modalCard o--modalCard" as |slide|>
      <div class="tOB--wizard">
        <div class="tOB--wizard__left">
          <figure class="o--mediaContainer">
            <img
              alt={{t "shared_phrases.splash_image"}}
              class="o--media"
              src="/assets/images/img--ob__postScheduled.png"
            />
            <b class="o--mediaOverlay"></b>
          </figure>
        </div>
        <div class="tOB--wizard__right">
          <div>
            {{component
              (concat
                "calendar/onboarding/wizards/schedule-first-post-successful/"
                this.scheduledFirstPostSuccessfulInfo.bodyComponent
              )
              profileType=@socialProfile.capitalizedProfileType
              text=this.scheduledFirstPostSuccessfulInfo.text
              title=this.scheduledFirstPostSuccessfulInfo.title
            }}
          </div>
  
          <footer class="tOB--wizard__footer--inner">
            {{component
              (concat
                "calendar/onboarding/wizards/schedule-first-post-successful/"
                this.scheduledFirstPostSuccessfulInfo.footerComponent
              )
              showTrialOptInModal=@showTrialOptInModal
              slide=slide
            }}
          </footer>
        </div>
      </div>
    </wizard.slide>
  </Shared::Wizard>
  */
  {
    "id": "r7ue9+Tj",
    "block": "[[[8,[39,0],null,[[\"@onFinish\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"slide\"]],null,[[\"@primaryClass\"],[\"tOB--modalCard o--modalCard\"]],[[\"default\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"tOB--wizard\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tOB--wizard__left\"],[12],[1,\"\\n        \"],[10,\"figure\"],[14,0,\"o--mediaContainer\"],[12],[1,\"\\n          \"],[10,\"img\"],[15,\"alt\",[28,[37,1],[\"shared_phrases.splash_image\"],null]],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--ob__postScheduled.png\"],[12],[13],[1,\"\\n          \"],[10,\"b\"],[14,0,\"o--mediaOverlay\"],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tOB--wizard__right\"],[12],[1,\"\\n        \"],[10,0],[12],[1,\"\\n          \"],[46,[28,[37,3],[\"calendar/onboarding/wizards/schedule-first-post-successful/\",[30,0,[\"scheduledFirstPostSuccessfulInfo\",\"bodyComponent\"]]],null],null,[[\"profileType\",\"text\",\"title\"],[[30,4,[\"capitalizedProfileType\"]],[30,0,[\"scheduledFirstPostSuccessfulInfo\",\"text\"]],[30,0,[\"scheduledFirstPostSuccessfulInfo\",\"title\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[10,\"footer\"],[14,0,\"tOB--wizard__footer--inner\"],[12],[1,\"\\n          \"],[46,[28,[37,3],[\"calendar/onboarding/wizards/schedule-first-post-successful/\",[30,0,[\"scheduledFirstPostSuccessfulInfo\",\"footerComponent\"]]],null],null,[[\"showTrialOptInModal\",\"slide\"],[[30,5],[30,3]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[3]]]]],[1,\"\\n\"]],[2]]]]]],[\"@transition\",\"wizard\",\"slide\",\"@socialProfile\",\"@showTrialOptInModal\"],false,[\"shared/wizard\",\"t\",\"component\",\"concat\"]]",
    "moduleName": "calendar/components/calendar/onboarding/wizards/schedule-first-post-successful/index.hbs",
    "isStrictMode": false
  });

  var _successfullyScheduled = /*#__PURE__*/new WeakSet();

  class ScheduleFirstPostSuccessfulComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _successfullyScheduled);
    }

    get recentlyScheduledPost() {
      return this.args.socialProfile.grams.reduce((mostRecentGram, gram) => mostRecentGram?.createdTime > gram?.createdTime ? mostRecentGram : gram);
    }

    get scheduledFirstPostSuccessfulInfo() {
      const publishingMethod = this.recentlyScheduledPost?.autoPublish ? 'auto' : 'manual';
      return _classPrivateMethodGet(this, _successfullyScheduled, _successfullyScheduled2).call(this, {
        publishingMethod
      });
    }

  }

  _exports.default = ScheduleFirstPostSuccessfulComponent;

  function _successfullyScheduled2(_ref) {
    let {
      publishingMethod
    } = _ref;
    return {
      title: 'title',
      text: `desc_${publishingMethod}`,
      bodyComponent: 'body',
      footerComponent: 'footer'
    };
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ScheduleFirstPostSuccessfulComponent);
});